import { Service, PortfolioItem, ContactInfo } from '../types'

export const services: Service[] = [
  {
    id: '1',
    tag: 'Pratik Deneyim',
    number: '01',
    title: 'PRATİK\nDENEYİM',
    description: 'Öğrencilerimize gerçek projeler üzerinde çalışma fırsatı sunuyoruz. Teorik bilgiyi pratik deneyimle birleştirerek iş hayatına hazırlıyoruz.',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80',
    serviceType: 'kurumsal-web'
  },
  {
    id: '2',
    tag: 'Mentörlük',
    number: '02',
    title: 'MENTÖRLÜK\nDESTEĞİ',
    description: 'Deneyimli ekibimiz öğrencilerimize rehberlik ediyor. Her adımda yanlarında olarak başarılı projeler üretmelerine yardımcı oluyoruz.',
    image: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&q=80',
    serviceType: 'urun-yonetim'
  },
  {
    id: '3',
    tag: 'Kazanç Fırsatı',
    number: '03',
    title: 'KAZANÇ\nFIRSATI',
    description: 'Öğrencilerimiz proje teslim ederek 1.5k - 3k arası kazanç elde edebilirler. Hem öğreniyor hem de kazanıyorlar.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    serviceType: 'e-ticaret'
  }
]

export const portfolioItems: PortfolioItem[] = [
  { url: 'https://www.rosewebdesignpro.com', domain: 'rosewebdesignpro.com', category: 'kurumsal', title: 'Rose Web Design Pro' },
  { url: 'https://ercantarimm.com', category: 'kurumsal', title: 'Ercan Tarım' },
  { url: 'https://gidproje.com', category: 'urunyonetim', title: 'Gid Proje' },
  { url: 'https://alyegitim.org', category: 'egitim', title: 'Aly Eğitim' },
  { url: 'https://marmaradagitim.com', category: 'lojistik', title: 'Marmara Dağıtım' },
  { url: 'https://www.cetinyolyardim.com', category: 'diger', title: 'Çetin Yol Yardım' },
  { url: 'https://www.nakolog.com', category: 'lojistik', title: 'Nakolog' },
  { url: 'https://melowajans.com', category: 'kurumsal', title: 'Melo Ajans' },
  { url: 'https://www.multintermodal.com', category: 'lojistik', title: 'Mult Intermodal' },
  { url: 'https://gayrethalıyıkama.com', category: 'diger', title: 'Gayret Halı Yıkama' },
  { url: 'https://veliogluglobal.com.tr', category: 'lojistik', title: 'Velioglu Global' },
  { url: 'https://gastro-orient.com', category: 'diger', title: 'Gastro Orient' },
  { url: 'https://rulersapologize.com', category: 'kurumsal', title: 'Rulers Apologize' },
  { url: 'https://ariakademi.com.tr', category: 'egitim', title: 'Ari Akademi' },
  { url: 'https://gulcemalguzellik.com', category: 'diger', title: 'Gülcemal Güzellik' },
  { url: 'https://e3dglobal.com', category: 'kurumsal', title: 'E3D Global' },
  { url: 'https://aselcambalkonsistemleri.com.tr', category: 'diger', title: 'Asel Cambalkon Sistemleri' }
]

export const contactInfo: ContactInfo = {
  email: 'info@3kdigitale.com',
  phone: '0539 854 87 97',
  location: 'Türkiye'
}

export const mockImages: Record<string, string> = {
  'rosewebdesignpro.com': 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1200&h=800&fit=crop',
  'ercantarimm.com': 'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=1200&h=800&fit=crop',
  'gidproje.com': 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&h=800&fit=crop',
  'alyegitim.org': 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200&h=800&fit=crop',
  'marmaradagitim.com': 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&h=800&fit=crop',
  'cetinyolyardim.com': 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1200&h=800&fit=crop',
  'nakolog.com': 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&h=800&fit=crop',
  'melowajans.com': 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=800&fit=crop',
  'multintermodal.com': 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=1200&h=800&fit=crop',
  'gayrethalıyıkama.com': 'https://images.unsplash.com/photo-1581539250439-c96689b516dd?w=1200&h=800&fit=crop',
  'veliogluglobal.com.tr': 'https://images.unsplash.com/photo-1586864387967-d02ef85d93e8?w=1200&h=800&fit=crop',
  'veliogluglobal.tr': 'https://images.unsplash.com/photo-1586864387967-d02ef85d93e8?w=1200&h=800&fit=crop',
  'gastro-orient.com': 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&h=800&fit=crop',
  'rulersapologize.com': 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&h=800&fit=crop',
  'ariakademi.com.tr': 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200&h=800&fit=crop',
  'gulcemalguzellik.com': 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=1200&h=800&fit=crop',
  'e3dglobal.com': 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=1200&h=800&fit=crop',
  'aselcambalkonsistemleri.com.tr': 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&h=800&fit=crop'
}
